import * as React from 'react';
import { connect } from 'react-redux';
import { IntelligentAssignmentSummaryEditHandlerComponent } from '../components';
import { photoCaptureIntelligentSetOCRUserVerifiedAction, photoCaptureIntelligentViewChangeAction, photoCaptureUploadAttachmentsAction } from '../actions';
import { getIntelligentEstimatorSelectedTileId, getPhotoCaptureAttachmentInfo, getPhotoCaptureCompanyCode, getPhotoCaptureContentType, getPhotoCaptureContextId, getPhotoCaptureCountryCode, getPhotoCaptureUserVehicleInfo, getPhotoCaptureVehicle } from '../selectors';
const mapStateToProps = (state) => {
    return {
        photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
        companyCode: getPhotoCaptureCompanyCode(state),
        contextId: getPhotoCaptureContextId(state),
        countryCode: getPhotoCaptureCountryCode(state),
        selectedAttachmentId: getIntelligentEstimatorSelectedTileId(state),
        contentType: getPhotoCaptureContentType(state),
        userVehicleInfo: getPhotoCaptureUserVehicleInfo(state),
        vehicle: getPhotoCaptureVehicle(state)
    };
};
const mapDispatchToProps = (dispatch) => ({
    onViewChange: (view, sequenceScreenName) => {
        dispatch(photoCaptureIntelligentViewChangeAction(view, sequenceScreenName));
    },
    onUploadAttachments: (attachmentInfo, contextId, coCode) => {
        dispatch(photoCaptureUploadAttachmentsAction(attachmentInfo, contextId, coCode));
    },
    onSetOCRUserVerified: (contentType) => {
        dispatch(photoCaptureIntelligentSetOCRUserVerifiedAction(contentType));
    }
});
const IntelligentAssignmentSummaryEditHandlerWrapper = (props) => {
    return React.createElement(IntelligentAssignmentSummaryEditHandlerComponent, Object.assign({}, props));
};
export const ConnectedIntelligentAssignmentSummaryEditHandlerComponent = connect(mapStateToProps, mapDispatchToProps)(IntelligentAssignmentSummaryEditHandlerWrapper);
//# sourceMappingURL=ConnectedIntelligentAssignmentSummaryEditHandlerComponent.js.map